<template>
    <div></div>
</template>

<script>
import Helper from '@/assets/js/Helper.js'
import { useCookies } from "vue3-cookies"

export default {
    name: 'Ref',
    data() {
        return {
            cookies: useCookies(),
            ref: null
        }
    },
    beforeCreate(){
        this.helper = new Helper()
    },
    async mounted() {
        try {
            const ref = (this.$route && this.$route.params && this.$route.params.code) ? this.$route.params.code : null
            this.ref = ref
            if (ref) {
                const ref_store = this.$store.getters.StateRef
                const ref_cookie = this.cookies.cookies.get("ref")
                const ref_localstorage = localStorage.getItem('ref')

                if(!ref_localstorage) localStorage.setItem('ref', ref)

                if(!ref_cookie) this.cookies.cookies.set("ref", ref)
   
                if(!ref_store){
                    try{
                        await this.$store.dispatch('SetRef', ref).then(() => {})
                    } catch {}
                }
            }
        } catch (e) {
            console.log(e)
        }
        this.$router.replace('/')
    },
}
</script>